export default "__VITE_ASSET__D1fGD0mb__"